import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function startTimeAfterMarketPeriodBuilder({parsedStatusObj}) {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Trade plan start time not applicable with desired market period. Start
        time:{' '}
        {parsedStatusObj.startHour && parsedStatusObj.startMin
          ? parsedStatusObj.startHour + ':' + parsedStatusObj.startMin
          : 'unknown'}
        . Period:{' '}
        {parsedStatusObj.desiredPeriod
          ? parsedStatusObj.desiredPeriod
          : 'unknown'}
        .
      </Body3>
    </td>
  );
}
